module.exports = __webpack_public_path__ + "static/1-bb77d33a56a7fb7aad07727ba8a80702.jpg";